module.exports = __webpack_public_path__ + "img/icon_command_night.badbdbf4.svg";